import { Injectable } from "@angular/core";
import { BaseProvider } from "../../../../shared/providers/base-provider";
import { WeatherPointNotifier } from "./weather-point-notifier";
import { WeatherPointState } from "./weather-point-state";

@Injectable()
export class WeatherPointProvider extends BaseProvider<
  WeatherPointNotifier,
  WeatherPointState
> {
  constructor() {
    super(WeatherPointNotifier);
  }
}
